module.exports = __webpack_public_path__ + "static/media/logo.964cd39e.png";